// Shared by the browser and the application endpoint. All money is settled in whole yen.
const pairs = { '(': ')', '（': '）', '[': ']', '［': '］', '{': '}', '｛': '｝', '【': '】', '〔': '〕', '〈': '〉', '《': '》' };
function countScript(text) {
  const stack = [];
  let countedText = '';
  let unmatched = false;
  for (const char of String(text).normalize('NFC')) {
    if (pairs[char]) { stack.push(pairs[char]); continue; }
    if (Object.values(pairs).includes(char)) {
      if (stack[stack.length - 1] === char) stack.pop();
      else unmatched = true;
      continue;
    }
    if (!stack.length && /[\p{L}\p{N}\p{P}]/u.test(char)) countedText += char;
  }
  return { count: Array.from(countedText).length, countedText, unmatched: unmatched || stack.length > 0 };
}
function calculateVoiceQuote(text, { binaural = false, video = false, rate = 1.5, tip = 0, withholding = true } = {}) {
  if (!['number', 'string'].includes(typeof rate) || !/^\d+(?:\.\d{1,2})?$/.test(String(rate)) || Number(rate) < 0.01 || Number(rate) > 10000) throw new Error('単価は0.01〜10,000円、小数第2位までで入力してください。');
  const rateHundredths = Math.round(Number(rate) * 100);
  if (!['number', 'string'].includes(typeof tip) || !/^\d*$/.test(String(tip)) || !Number.isSafeInteger(Number(tip)) || Number(tip) < 0 || Number(tip) > 100000000) throw new Error('チップは0〜100,000,000円の整数で入力してください。');
  const tipYen = Number(tip);
  const script = countScript(text);
  const base = Math.floor(script.count * rateHundredths / 100);
  const extra = binaural ? 1000 : 0;
  const videoExtra = video ? 5000 : 0;
  const subtotal = base + extra + videoExtra + tipYen;
  const consumptionTax = Math.floor(subtotal / 10);
  const gross = subtotal + consumptionTax;
  const tax = withholding ? Math.floor((Math.min(gross, 1000000) * 1021 + Math.max(gross - 1000000, 0) * 2042) / 10000) : 0;
  return { ...script, rate: rateHundredths / 100, base, extra, videoExtra, tip: tipYen, subtotal, consumptionTax, gross, tax, net: gross - tax, withholding };
}
module.exports = { countScript, calculateVoiceQuote };
